import { render, staticRenderFns } from "./PaymentMethodInstanceUIForm.vue?vue&type=template&id=853350f2"
import script from "./PaymentMethodInstanceUIForm.vue?vue&type=script&lang=js"
export * from "./PaymentMethodInstanceUIForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports